/**
 * Extend ImportMeta to include 'env' for Vite environment variables
 */
declare global {
  interface ImportMetaEnv {
    readonly VITE_APP_MAPBOX_TOKEN: string
    readonly VITE_LINGO_DEV?: string
    readonly VITE_LINGO_PROJECT_ID?: string
    readonly VITE_APP_API_BASE_URL?: string
    readonly VITE_SHADEMAP_API_KEY?: string
    readonly VITE_APP_SOME_OTHER_ENV?: string
    readonly DEV?: boolean
    // add other env variables here if needed
  }

  interface ImportMeta {
    readonly env: ImportMetaEnv
  }
}

/**
 * Mapbox access token
 * This should be provided by the consuming application
 */
export const MAPBOX_TOKEN =
  import.meta.env.VITE_APP_MAPBOX_TOKEN ||
  'pk.eyJ1IjoicG9wZXR5IiwiYSI6ImNpdDlydDEwYzBsMWYydXAyeXhrMHhoamIifQ.9_sT8uJ8zd_6sU0ispPK3w'

/**
 * Mapbox light style
 */
export const LIGHT_MAPSTYLE = 'mapbox://styles/mapbox/light-v10'

/**
 * Mapbox street style
 */
export const STREET_MAPSTYLE = 'mapbox://styles/mapbox/streets-v11'

/**
 * Popety zones style
 */
export const ZONE_MAPSTYLE = 'mapbox://styles/popety/cl3a7v8hy001y14pejeo2af8o'

/**
 * Satellite Popety zones style
 */
export const ZONE_SATELLITE_MAPSTYLE =
  'mapbox://styles/popety/clfi67w71001601mpthh1rl52'

/**
 * Default map style
 */
export const DEFAULT_MAPSTYLE =
  'mapbox://styles/popety/cm7mg342r00u001s21uzzd25t'

/**
 * All mapbox styles
 */
export const styles = [
  'mapbox://styles/popety/cm7mg342r00u001s21uzzd25t',
  LIGHT_MAPSTYLE,
  'mapbox://styles/popety/cl449l1ah000414umwqgcr0pd',
  STREET_MAPSTYLE,
  'mapbox://styles/popety/cl9mkt6w3002714rsqw7qsz7g',
  ZONE_MAPSTYLE,
] as string[]

export const API_BASE_URL =
  import.meta.env.VITE_APP_API_BASE_URL || 'https://api.popety.io'

/**
 * switzerland geo center
 */
export const SWITZERLAND_GEO_CENTER = [8.304620661, 46.813258144] as [
  number,
  number,
]

/**
 * Shademap token
 */
export const SHADEMAP_API_KEY = import.meta.env.VITE_SHADEMAP_API_KEY
